import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { identify as posthogIdentify } from "@/lib/analytics";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sid) {
      navigate("/");
      return;
    }
    api
      .post("/auth/session", { session_id: sid })
      .then((res) => {
        // Populate the global AuthContext synchronously so the destination
        // route renders with the user already known (no /auth/me race).
        setUser(res.data);
        posthogIdentify(res.data);
        const dest = res.data?.role === "admin" ? "/admin" : "/dashboard";
        navigate(dest, { replace: true, state: { user: res.data } });
      })
      .catch(() => navigate("/"));
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-sm text-muted-foreground">Signing you in…</div>
    </div>
  );
}
